import axios from 'axios';

// ✅ 사용자 관련 API BASE
const API_USER_BASE = '/api/auth/users';

// ✅ 토큰에서 payload 디코딩
export const decodeToken = (token) => {
  try {
    const base64Payload = token.split('.')[1];
    const jsonPayload = decodeURIComponent(
      atob(base64Payload)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (err) {
    console.error('토큰 디코딩 실패:', err);
    return null;
  }
};


// 📑 사용자 ID 기준 조회
export const getUserById = async (id, token) => {
  try {
    const res = await axios.get(`${API_USER_BASE}/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data; 
    // {id, userid, name, role, dept_code, dept_name, position, ...}
  } catch (err) {
    console.error('사용자 정보 조회 실패:', err);
    throw err;
  }
};

// 📑 현재 로그인 사용자 조회 (토큰 → id 추출 → /users/:id 호출)
export const getCurrentUser = async (token) => {
  try {
    const payload = decodeToken(token);
    if (!payload || !payload.id) {
      throw new Error('토큰에서 사용자 ID를 추출할 수 없습니다.');
    }
    const res = await axios.get(`${API_USER_BASE}/${payload.id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    //console.log(res.data);
    return res.data; // {id, userid, name, role, dept_code, dept_name, position, ...}
  } catch (err) {
    console.error('현재 사용자 조회 실패:', err);
    throw err;
  }
};

// 현재 선택된 회사코드 조회 (토큰 payload 우선, sessionStorage fallback)
export const getCurrentComCode = (token) => {
  const resolvedToken = token || sessionStorage.getItem('token') || '';
  const byStorage = String(sessionStorage.getItem('M_ComCode') || '').trim();

  const payload = resolvedToken ? decodeToken(resolvedToken) : null;
  const byToken = String(payload?.M_ComCode || '').trim();

  // 토큰 값이 있으면 항상 최신값으로 취급하고 storage와 동기화한다.
  if (byToken) {
    if (byStorage !== byToken) {
      sessionStorage.setItem('M_ComCode', byToken);
    }
    return byToken;
  }

  return byStorage;
};


/* 
👉 앞으로 다른 공통 API도 이 파일에 추가 가능:
예: 조직 정보, 권한 정보, 공통 코드 조회 등
*/